<div
	class="banner-container shadow-md d-flex justify-content-between align-items-start p-3 px-4"
	[ngClass]="theme"
	*ngIf="open"
>
	<ng-content></ng-content>
	<mat-icon (click)="open = !open">close</mat-icon>
</div>
